/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import './KhuyenMai.scss';

const tabs = [
  'โปรโมชั่นล่าสุด',
  // 'Khuyến mãi hàng ngày',
  // 'Khuyến Mãi Nạp',
  // 'Xổ Số',
  // 'Hoàn Trả',
  // 'Casino',
  // 'Thể Thao',
  // 'Game Điện Tử',
  // { label: 'Thu Thập Thưởng', icon: './img/activity/icon-collect.png' },
];

const tabContents = [
  // Tab 1
  [
    {
      id: 2948,
      img: './KM1.png',
      link: 'https://qh11.com/',
    },
    {
      id: 2732,
      img: './KM2.png',
      popupImg: 'https://upload.qh089.com/p/20250502/lion/21/10335684/jpg/1746162847377.jpg',
    }
  ],
  // Tab 2
  [
    {
      id: 3,
      img: 'https://upload.qh089.com/p/20250411/cx_sports/21/14932445/png/1744362053331.png',
    },
    {
      id: 1,
      img: 'https://upload.qh089.com/p/20250411/cx_sports/21/14932445/png/1744362111373.png',
    },
  ],
  // Tab 3 (same as tab 1 for example)
  [
    {
      id: 2732,
      img: 'https://upload.qh089.com/p/20250502/lion/21/10335684/png/1746181833836.png',
      popupImg: 'https://upload.qh089.com/p/20250502/lion/21/10335684/jpg/1746162847377.jpg',
    },
  ],
  'no-data',
];

const KhuyenMai = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupImg, setPopupImg] = useState('');

  const handlePopup = (imgUrl) => {
    setPopupImg(imgUrl);
    setShowPopup(true);
  };

  return (
    <main className="act-box">
      <div className="tab wrapact container" id="actList">
        <ul className="tab_ctrl ctrl">
          {tabs.map((tab, index) => (
            <li
              key={index}
              className={`tab_btn ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {typeof tab === 'string' ? (
                tab
              ) : (
                <>
                  <img src={tab.icon} alt="" />
                  <span>{tab.label}</span>
                </>
              )}
            </li>
          ))}
        </ul>

        <div className="tab_main main">
          {tabContents.map((content, index) => (
            <ul
              key={index}
              className={`tab_item itemBox ${activeTab === index ? 'active' : ''}`}
              style={{ display: activeTab === index ? 'block' : 'none' }}
            >
              {content === 'no-data' ? (
                <li className="nodata">
                  <div className="no-activities">
                    <img src="./img/activity/collect/noData.png" alt="" />
                    <div style={{ color: 'white', fontSize: '18px' }}>Không có tiền thưởng</div>
                  </div>
                </li>
              ) : (
                content.map((item) => (
                  <li
                    key={item.id}
                    className="item-box"
                    onClick={() => item.popupImg && handlePopup(item.popupImg)}
                    style={{ position: 'relative' }}
                  >
                    <img src={item.img} alt="" />
                  </li>
                ))
              )}
            </ul>
          ))}
        </div>
      </div>

      {showPopup && (
        <div className="event_content pop">
          <div className="mask btn_close" onClick={() => setShowPopup(false)}></div>
          <div className="adBox">
            <div className="box">
              <a href="javascript:;">
                <img src={popupImg} alt="Popup" />
              </a>
            </div>
            <span className="btn_close close" onClick={() => setShowPopup(false)}></span>
          </div>
        </div>
      )}
    </main>
  );
};

export default KhuyenMai;
